import { type FC, useEffect, useRef } from "react";
import { DefinitionList } from "@root/shared/components/DefinitionList";
import { useReadMoreButtonHeight } from "@root/shared/components/ReadMoreButton/useReadMoreButtonHeight";
import * as styles from "./styles.css";

type Props = {
  userCareerInfoList: { term: string; description: string | string[] }[][];
};

export const UserCareerDefinitionList: FC<Props> = ({ userCareerInfoList }) => {
  const setContainerHeight = useReadMoreButtonHeight();
  const elementRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (elementRef.current && setContainerHeight) {
      // ボタンを表示する高さは１つ目の要素の高さ
      setContainerHeight(elementRef.current.clientHeight);
    }
  }, [setContainerHeight]);

  return (
    <>
      {userCareerInfoList.map((userCareerInfoListItems, index) => (
        <DefinitionList
          // eslint-disable-next-line react/no-array-index-key
          key={`${userCareerInfoListItems[0].term}_${index}`}
          title={`職務経歴${index + 1}`}
          items={userCareerInfoListItems}
          className={styles.definitionListContainer}
          elementRef={index === 0 ? elementRef : null}
        />
      ))}
    </>
  );
};
